import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { chatId: Number };

  select(event) {
    const suggestion = event.currentTarget.dataset.suggestion;
    const form = document.getElementById(`new_message_${this.chatIdValue}`);
    if (!form) return;

    const input =
      form.querySelector("textarea[name='message[content]']") ||
      form.querySelector("input[name='message[content]']");
    if (!input) return;

    input.value = suggestion;
    form.requestSubmit();

    // Hide the empty state after selecting
    const emptyState = this.element.querySelector("#chat_empty_state");
    if (emptyState) emptyState.remove();
  }
}
